import { TabNav } from '@/components/TabNav';
import type { ConsiderationType, TaskType } from '@rock/types';
import type { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ProcessHowOftenResultEntry } from './ProcessHowOftenResultEntry';
import { ProcessHowOftenResultsTable } from './ProcessHowOftenResultsTable';

export const TaskTypeAiResultsPage: FC<{ taskType: TaskType; considerationType: ConsiderationType }> = ({
    taskType,
    considerationType,
}) => {
    const basePath = `/content/considerations/${considerationType.id}/tasks/${taskType.id}/ai-results`;

    return (
        <div className="space-y-6">
            <div className="mb-4">
                <TabNav tabs={[{ label: 'Process How Often Results', to: `${basePath}/process-how-often-results` }]} />
            </div>
            <Routes>
                <Route index element={<Navigate replace to="./process-how-often-results" />} />
                <Route path="process-how-often-results" element={<ProcessHowOftenResultsTable taskType={taskType} />} />
                <Route
                    path="process-how-often-results/:resultId"
                    element={<ProcessHowOftenResultEntry taskType={taskType} />}
                />
            </Routes>
        </div>
    );
};
